import GaugeCsat from './GaugeCsat';
export default GaugeCsat;



// WEBPACK FOOTER //
// ./src/components/GaugeCsat/index.js